<template>
    <div class="main d-flex flex-column">
        <component 
            v-if="announcements.length > 0" 
            :is="setParallels" 
            :announcements="announcements"
            isPreview
            class="flex-grow-1"
        ></component>
    </div>
</template>

<script>
    import OneParallel from "./Parallels/OneParallel";
    import TwoParallels from "./Parallels/TwoParallels";
    import ThreeParallels from "./Parallels/ThreeParallels";
    import FourParallels from "./Parallels/FourParallels";
    import BasicFallback from "./Fallbacks/BasicFallback";
    import Footer from "../../components/Footer";
    import {config} from "../../config"

    export default {
        name: "DisplayManager",

        components: {
            OneParallel,
            TwoParallels,
            ThreeParallels,
            FourParallels,
            BasicFallback,
            Footer
        },

        data() {
            return {
                announcements: [],
                imageUrl: undefined,
                error: undefined
            }
        },

        created() {
            window.addEventListener('message', event => {
                // IMPORTANT: check the origin of the data! 
                if (event.origin.startsWith(config.administrationUrl)) { 
                    event.data.announcement.imageUrl = event.data.announcement.announcementImagePath ? event.data.announcement.announcementImagePath : undefined;
                    const previewOrientation = event.data.announcement.previewOrientation;
                    if (previewOrientation == 'portrait') {
                        this.announcements = [ event.data.announcement, event.data.announcement ]; 
                    } else if (previewOrientation == 'landscape') {
                        this.announcements = [ event.data.announcement, event.data.announcement, event.data.announcement ];     
                    } else {
                        this.announcements = [ event.data.announcement ]; 
                    }
                }
            }); 
        },

        computed: {
            setParallels() {
                switch (this.announcements.length) {
                    case 1:
                        return "OneParallel";
                    case 2:
                        return "TwoParallels";
                    case 3:
                        return "ThreeParallels";
                    case 4:
                        return "FourParallels";
                    default:
                        return "BasicFallback";
                }
            }
        },

        methods: {
        },
    }
</script>

<style scoped>
    .main {
        width: 100vw;
        height: 100vh;
    }
</style>